/* eslint-disable react-hooks/exhaustive-deps */
import React, {  useEffect, useState } from "react";
import { BrowserRouter as Router, useLocation, useNavigate } from "react-router-dom";
import AuthContext from "../hooks/authContext";
import AppRoutes from "./app-route";
import theme from "../theme";
import Loader from "../components/AppLoader/Loader";
import { ThemeProvider } from "@material-ui/core/styles";
import { CssBaseline } from "@material-ui/core";
import { setLoginToken, clearLoginToken } from "../services/storage";
import { EventEmitter } from "../services/event.service";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { logOut, getCurrentUser } from "../services/firebase";
import {
  getSuppliesListCount,
  getSupplyOrderList,
} from "../services/apiservices/supplies";
import { getIssueListCount } from "../services/apiservices/issues";
import moment from "moment";
import {
  getCompanyEmployees,
  getEmployee,
} from "../services/apiservices/employee";
import {
  getChannelList,
  getUsedStorage,
} from "../services/apiservices/messages";
import { fetchSubscriptionWithCustomer, getPendingPaymentVerificationByUser } from "../services/apiservices/users";
import { getCompanyClients } from "../services/apiservices/client";
import { useTour } from "../components/ui/TourContext";
import { getSupportListCount } from "../services/apiservices/support";

function App(props) {
  const [authstatus, setauthstatus] = useState(false);
  const [substatus, setsubstatus] = useState(false);
  const [userProfile, setUserProfile] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [emps, setEmps] = useState([]);
  const [clients, setClients] = useState([]);
  const [currentChannel, setCurrentChannel] = useState();
  const [isReadPublic, setIsReadPublic] = useState();
  const [isReadPrivate, setIsReadPrivate] = useState();
  const [supplyId, setSupplyId] = useState();
  const [supplieStatusCount, setSupplieStatusCount] = useState({
    Pending: 0,
    OPEN: 0,
  });
  const [pendingSupplyStatus, setPendingSupplyStatus] = useState([]);
  const [pendingSupportStatus, setPendingSupportStatus] = useState(0);
  const [highPrioritySupply, setHighPrioritySupply] = useState([]);
  const [appointmentsData, setAppointmentsData] = useState({});
  const [editAppointmentData, setEditAppointmentData] = useState({});
  const [updateAppointmentData, setUpdateAppointmentData] = useState({});
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedAppointment, setSelectedAppointment] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loginBack, setLoginBack] = useState(false);
  const [issueCount, setIssueCount] = useState(0);
  const [newClientId, setNewClientId] = useState();
  const [newEmpId, setNewEmpId] = useState();
  const [allEmp, setAllEmps] = useState();
  const [tableState, setTableState] = useState({
    sort: false,
    rowsPerPage: 10,
  });
  const location = useLocation();
  const path = location.pathname;
  const navigate = useNavigate();
  const {startTour} = useTour(); 
  const localClientID = localStorage.getItem('clientId');
  const localCompanyId = localStorage.getItem('companyId');

  const getSupplyCount = async (companyId, role) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setPendingSupplyStatus([]);
      setSupplieStatusCount({});
      return;
    }

    await getSuppliesListCount(
      {
        status: ["Pending"],
        companyId: companyId,
      },
      (res) => {
        if (res[0]?.Pending === 0) {
          setPendingSupplyStatus([]);
        } else {
          setPendingSupplyStatus(res);
        }

        setSupplieStatusCount(res[0]);
      }
    );
  };

  const getSupportCount = async (companyId, userId, role) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setPendingSupportStatus(0);
      return;
    }

    await getSupportListCount(
      {
        userId: userId,
        companyId: companyId,
      },
      (res) => {
        if (res[0]?.unread === 0) {
          setPendingSupportStatus(0);
        } else {
          setPendingSupportStatus(res[0]?.unread);
        }

        setPendingSupportStatus(res[0]?.unread);
      }
    );
  };

  const getIssueCount = async (companyId, clientId, userId) => {
    await getIssueListCount(
      {
        companyId: companyId,
        clientId: clientId,
        userId: userId
      },
      (res) => {
        if (res?.[0]?.unread === 0) {
          setIssueCount(0);
        } else {
          setIssueCount(res?.[0]?.unread);
        }
      }
    );
  };

  const getHighPrioritySupply = async (companyId, role, userId) => {
    const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    if (isClient) {
      setHighPrioritySupply([]);
      return;
    }

    await getSupplyOrderList( { companyId, statusNotIn: ["Pending", "Rejected"] }, (res) => {
      // let records = res.filter(
      //   (order) => order.status !== "Pending" && order.status !== "Rejected"
      // );
      let filterRecords = res?.filter((order) => {
        const readUser = order?.readUser || [];
        const isUnread = !readUser.includes(userId);
        const archive = !order?.archive
        return (
          ((order?.status !== "Delivered" || isUnread) && archive) 
        );
      });
      setHighPrioritySupply(filterRecords);
    });
  };

  const getTheChannelList = async (companyId, id, role) => {
     const isClient = Array.isArray(role) ? role.includes("Client") : role === "Client";
    getChannelList(companyId,
      (res) => {
        if (res) {
          const data = res?.filter((item)=> item.status !== false);
          let isReadPriv = true;
          let isReadPubl = true;
          data?.forEach((element) => {
            if (element.type === "Private") {
              if (isClient && element?.client !== id) {
                return;
              }
              if (isReadPriv) {
                isReadPriv = element?.readMsgUsers?.includes(id) ? true : false;
              }
            } else {
              if (isReadPubl) {
                isReadPubl = element?.readMsgUsers?.includes(id) ? true : false;
              }
            }
          });

          setIsReadPublic(isReadPubl);
          setIsReadPrivate(isReadPriv);
        }
      },
      (resError) => {
        console.log("reserror", resError);
      }
    );
  };

  useEffect(() => {
    const excludedRoutes = [
      "/login",
      "/register",
      "/verify-email-sent",
      "/verify-email",
      "/verify-new-email",
      "/updatepassword",
      "/forgotpassword"
    ];

    if (excludedRoutes.includes(path)) {
      console.log("Skipping login for this route:", path);
    } else {
      login();
    }
  }, [path]);

  const resetPendingSupplyStatus = () => setPendingSupplyStatus([]);
  const resetPendingSupportStatus = () => setPendingSupportStatus();
  const resetHighPrioritySupply = () => setHighPrioritySupply([]);
  const resetIssueCount = () => setIssueCount(0);

  const validateSubscription = (subscriptionEndTimestamp) => {
    const subscriptionEndDate = moment.unix(subscriptionEndTimestamp).format("YYYY-MM-DD");
    const today = moment().format("YYYY-MM-DD");
    return subscriptionEndDate >= today;
  };

  const isSubscriptionValid = (subscription, fallback) => {
    const now = moment().unix();
    const endTimestamp =
      fallback?.current_period_end || fallback?.items?.data?.[0]?.current_period_end || subscription?.current_period_end;
    const status = fallback?.status || subscription?.status;
    const cancelAtPeriodEnd =
      fallback?.current_period_end || fallback?.items?.data?.[0]?.current_period_end || subscription?.current_period_end || false;

    return (
      endTimestamp &&
      validateSubscription(endTimestamp) &&
      (["active", "trialing"].includes(status) ||
        (status === "canceled" && cancelAtPeriodEnd && now <= endTimestamp))
    );
  };

  const login = async (token) => {
    setIsLoading(true);
    const auth = getAuth();
    return onAuthStateChanged(auth, async (user) => {
      if (!user) {
        setauthstatus(false);
        setsubstatus(false);
        setIsLoading(false);
        return;
      }
      try {
        const userData = auth.currentUser;
        const currentuser = await getCurrentUser();
        const currentUserData = currentuser?.userData || {};

        let userRoles = [];

        if (Array.isArray(currentUserData?.role)) {
          userRoles = [...currentUserData.role];
        } else if (typeof currentUserData?.role === "string") {
          userRoles = [currentUserData.role];
        }

        if (userRoles?.includes("Employee") && currentUserData?.employeerole) {
          userRoles.push(currentUserData.employeerole);
        }

        userRoles = [...new Set(userRoles?.filter(Boolean))];

        const isClient = userRoles?.includes("Client");
        const isCompanyUser = userRoles?.includes("companyUser");
        const isSuperUser = userRoles?.includes("superUser");
        // const role = currentUserData?.role === "Employee"
        //   ? currentUserData?.employeerole
        //   : currentUserData?.role;
        const companyId = isClient ? localCompanyId || currentUserData?.companyId : isCompanyUser ? currentUserData?.id : currentUserData?.companyId;

        // const companyId = currentUserData?.role === "Client" ? localCompanyId ? localCompanyId : currentUserData?.companyId : currentUserData?.role === "companyUser" ? currentUserData?.id : currentUserData?.companyId;

        if (isSuperUser) {
          setLoginBack(false);
          setLoginToken(currentuser?.token);
          setUserProfile({
            ...currentUserData,
            // role,
            lastLogin: userData?.metadata?.lastSignInTime,
          });
          setauthstatus(true);
          setsubstatus(false);
          setIsLoading(false);
          return;
        }
        
        // if (currentUserData?.role === "companyUser" && !user.emailVerified) {
        //   setIsLoading(false);
        //   navigate("/verify-email-sent");
        //   return;
        // }

        let pendingVerifications = [];

        if (isCompanyUser) {
          const result = await getPendingPaymentVerificationByUser(currentUserData?.id);
          if (result?.length > 0) {
            pendingVerifications = result;
          }
        }

        const [subscriptionData, storage, allEmpRes, clientRes, companyData] = await Promise.all([
          fetchSubscriptionWithCustomer(currentUserData?.customer),
          getUsedStorage(companyId),
          new Promise((resolve, reject) => {
            getCompanyEmployees(
              companyId,
              (res) => resolve(res),
              (err) => resolve({ status: false, data: [] })
            );
          }),
          new Promise((resolve, reject) => {
            getCompanyClients(
              companyId,
              (res) => resolve(res),
              (err) => resolve({ status: false, data: [] })
            );
          }),
          new Promise((resolve) => getEmployee(companyId, resolve)),
        ]);

          const clientsDetails = clientRes?.data ? clientRes?.data?.filter((item)=> item?.status !== false) : [];
          setClients(clientsDetails);

          const employees = allEmpRes?.data ? allEmpRes?.data?.filter((item)=> item?.status !== false) : [];
          setEmps(employees);

        if (userRoles.includes("companyUser") && !user.emailVerified){
          setIsLoading(false);
          navigate("/verify-email-sent");
          return;
        }

        if (!subscriptionData?.data?.length) {
          setIsLoading(false);
          return;
        }

        setLoginToken(currentuser?.token);

        const allEmps = allEmpRes?.data || [];
        setAllEmps(allEmps);

        getSupplyCount(companyId, currentUserData?.role);
        getSupportCount(companyId, currentUserData?.id, currentUserData?.role);
        getHighPrioritySupply(companyId, currentUserData?.role, currentUserData?.id);
        getIssueCount(companyId, currentUserData?.client, currentUserData?.id);
        getTheChannelList(companyId, currentUserData?.id, currentUserData?.role);

        const subscriptions = subscriptionData?.data || [];
        const blockedPriceIds = [
          "price_1R1Pm6H54HzvHwSdzS4aA0s9",
          "price_1RGH20H54HzvHwSdZTHWjNHO",
        ];

        const filteredSubs = subscriptions?.filter(
          (sub) =>
            !sub?.items?.data?.some((item) =>
              blockedPriceIds?.includes(item?.price?.id)
            )
        );
        const canceledSubs = filteredSubs?.filter((sub) => sub?.status === "canceled");

        const fallbackSub = filteredSubs?.find((sub) => sub?.status === "active") ||
          filteredSubs?.find((sub) => sub?.status === "trialing") ||
          (canceledSubs?.length > 0
            ? canceledSubs?.reduce((latest, current) =>
                current?.created > latest?.created ? current : latest
              )
            : null);

        const userSub = currentUserData?.subscriptions?.data?.[0];
        const additionalSub = currentUserData?.subscriptions?.additionalData?.[0];

        const subscriptionEndTimestamp =
          fallbackSub?.current_period_end || userSub?.current_period_end;
        const subscriptionStatus = fallbackSub?.status || userSub?.status;
        const subscriptionId = fallbackSub?.plan?.product || userSub?.plan?.product;

        let quantity = 1;
        if (subscriptionStatus === "trialing") {
          quantity = 5;
        } else {
          const baseQty = userSub?.quantity || fallbackSub?.quantity || 0;
          const addQty =
            additionalSub?.status === "active" &&
            validateSubscription(additionalSub?.current_period_end)
              ? additionalSub?.quantity
              : 0;
          quantity = baseQty + addQty;
        }

        const companyActiveUsers =
          currentUserData?.role === "companyUser"
            ? allEmps?.filter(
                (e) =>
                  e.companyId === currentUserData?.id &&
                  e.role === "Employee" &&
                  e.status === true
              )?.length
            : 0;

        const isValid = isSubscriptionValid(userSub, fallbackSub);

        setUserProfile({
          ...currentUserData,
          // role,
          subscriptionDetails: fallbackSub,
          companyActiveUsers,
          lastLogin: userData?.metadata?.lastSignInTime,
          prdId: subscriptionId,
          additionalQuantity: (quantity > 1 && userSub?.quantity) ? quantity - (userSub?.quantity || 0) : 0,
          quantity,
          storage,
          clientsLength: clients?.length,
          employeesLength: employees?.length,
          employees: allEmpRes?.data,
          companyData: companyData,
          pendingVerifications: pendingVerifications || []
        });

        setauthstatus(true);
        setsubstatus(!isValid);
        setIsLoading(false);
      } catch (err) {
        console.error("Login error:", err);
        setauthstatus(false);
        setsubstatus(false);
        setIsLoading(false);
      }
    });
  };

  useEffect(() => {
    if (isLoading === true) return;
    const excludedRoutes = [
        "/",
        "/login",
        "/register",
        "/verify-email-sent",
        "/verify-email",
        "/updatepassword"
    ];
  if (excludedRoutes.includes(path)) return;
    const hasSeenTour = localStorage.getItem("hasSeenTour");
    if (!hasSeenTour && Array.isArray(clients) && Array.isArray(emps)) {
      if (clients?.length === 0 && emps?.length === 0) {
        localStorage.setItem("startTour", "getting-started");
        startTour("getting-started");
        // localStorage.setItem("hasSeenTour", "true");
      }
    }
  }, [isLoading, clients, emps]);

  const logoutuser = () => {
    clearLoginToken();
    logOut();
    setauthstatus(false);
    localStorage.clear();
    navigate('/login')
    setsubstatus(false);
    setLoginBack(true);
    setIsLoading(false);
  };
  EventEmitter.subscribe("logoutUser", logoutuser);

  return (
      <AuthContext.Provider
        value={{
          status: authstatus,
          userProfile: userProfile,
          login: login,
          currentChannel: currentChannel,
          setCurrentChannel: setCurrentChannel,
          isReadPrivate: isReadPrivate,
          isReadPublic: isReadPublic,
          setIsReadPrivate: setIsReadPrivate,
          setIsReadPublic: setIsReadPublic,
          logoutuser: logoutuser,
          pendingSupplyStatus: pendingSupplyStatus,
          highPrioritySupply: highPrioritySupply,
          setPendingSupplyStatus: setPendingSupplyStatus,
          issueCount: issueCount,
          setIssueCount: setIssueCount,
          isLoading: isLoading,
          resetPendingSupplyStatus,
          resetHighPrioritySupply,
          resetIssueCount,
          tableState,
          setTableState,
          setEditAppointmentData,
          setUpdateAppointmentData,
          updateAppointmentData,
          editAppointmentData,
          setAppointmentsData,
          appointmentsData,
          setSelectedAppointment,
          selectedAppointment,
          setIsModalOpen,
          isModalOpen,
          setIsExpanded,
          setNewClientId,
          newClientId,
          setNewEmpId,
          newEmpId,
          isExpanded,
          supplieStatusCount,
          setsubstatus,
          substatus,
          loginBack,
          setLoginBack,
          setPendingSupportStatus: setPendingSupportStatus,
          pendingSupportStatus: pendingSupportStatus,
          resetPendingSupportStatus,
          setSupplyId,
          supplyId
        }}
      >
        
        <ThemeProvider theme={theme}>
          {/* {isLoading === true && <Loader />} */}
          <CssBaseline />
          <AppRoutes {...props} isLoading={isLoading}/>
        </ThemeProvider>
      </AuthContext.Provider>
  );
}

export default App;
